import React, { useContext, useEffect } from 'react';
import { SortContext } from 'context/SortContext';
import { Divider } from 'styled_components/Common/Divider';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import { string } from 'prop-types';
import styled from 'styled-components';
import { DownArrowSVG } from 'styled_components/SVG/DownArrowSVG';

const handleColorType = (module, theme) => {
	switch (module.toLowerCase()) {
		case 'storage':
			return theme.storage;
		case 'account':
			return theme.account;
		case 'billing':
			return theme.billing;
		case 'support':
			return theme.support;
		case 'colocation':
			return theme.colocation;
		default:
			return theme.main;
	}
};

const SortStyle = styled.div`
	position: absolute;
	z-index: 1000;
	width: 152px;
	height: 40px;
	.divider {
		margin-top: 0px !important;
	}
	.filter-reveal {
		//transform: translate(-50%, 0%);
		position: absolute;
		//left: 50%;
		top: 0%;
		width: 152px;
		height: 0px;
		overflow: hidden;
		transition: width 2.5s, height 1s ease-in-out;
		margin-top: 40px;
		background: ${props => props.theme.white};

		.filter-dd-wrapper {
			width: 100%;
			height: 120px;
			&.three {
				height: 135px;
			}
			&.four {
				height: 160px;
			}
			&.long {
				height: 168px;
			}
			background: ${props => props.theme.white};

			.selected {
				display: flex;
				align-items: center;
				justify-content: center;
				text-transform: capitalize;
				height: 40px;
				color: ${props => handleColorType(props.module, props.theme)};
			}
			.filter-selections {
				position: relative;
				padding: 24px;
				padding-right: 32px;
				padding-top: 16px;
				padding-bottom: 40px;
				height: 160px;
				text-transform: capitalize;
				.selector {
					text-align: left;
					cursor: pointer;
					white-space: no-wrap;
					overflow: hidden;
					text-overflow: ellipsis;
					color: ${props => props.theme.Cool_Gray_Dark_2};
				}
				.selector:hover {
					font-family: 'ProximaNova-Bold';
				}
				.ScrollbarsCustom-Track {
					right: -19px !important;
					top: 0px !important;
				}
				.ScrollbarsCustom-ThumbY {
					background-color: ${props => handleColorType(props.module, props.theme)} !important;
					width: 6px !important;
				}
				.ScrollbarsCustom-TrackY:before {
					border-left: none;
				}
				.ScrollbarsCustom-TrackY {
					background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
					box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
						1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
					width: 6px !important;
				}
			}
		}
	}
	.filter-selected {
		width: 100%;
		height: 40px;
		white-space: nowrap;
		cursor: pointer;
		display: flex;
		align-items: flex-end;
		.filter-title {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: flex-end;
			.filter-heading {
				position: absolute;
				top: 0;
				left: 0;
			}
			.title {
				width: 100%;
				text-align: start;
				margin-bottom: 4px;
				&.active {
					color: ${props => handleColorType(props.module, props.theme)};
				}
			}
			.filter-icon-2 {
				width: 24px;
				margin-bottom: 2px;
				&.active {
					.cls-3 {
						fill: ${props => handleColorType(props.module, props.theme)} !important;
					}
				}
			}
		}
	}
	.filter-selected:hover {
		.filter-reveal {
			height: 120px;
			&.three {
				height: 135px;
			}
			&.four {
				height: 160px;
			}
			&.long {
				height: 168px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 168px;
		height: 56px;
		.filter-reveal {
			width: 168px;
			margin-top: 56px;
			.filter-dd-wrapper {
				height: 120px;
				&.three {
					height: 135px;
				}
				&.four {
					height: 165px;
				}
				&.long {
					height: 214px;
				}
				.selected {
					height: 40px;
				}
				.filter-selections {
					padding: 24px;
					padding-right: 40px;
					padding-top: 16px;
					height: 175px;
					.ScrollbarsCustom-Track {
						right: -18px !important;
						top: 0px !important;
					}

					.ScrollbarsCustom-ThumbY {
						width: 8px !important;
					}
					.ScrollbarsCustom-TrackY {
						width: 8px !important;
					}
				}
			}
		}
		.filter-selected {
			height: 56px;

			.filter-title {
				.title {
					margin-bottom: 10px;
					&.active {
						color: ${props => handleColorType(props.module, props.theme)};
					}
				}
				.filter-icon-2 {
					width: 24px;
					margin-bottom: 10px;
				}
			}
		}
		.filter-selected:hover {
			.filter-reveal {
				height: 120px;
				&.three {
					height: 135px;
				}
				&.four {
					height: 165px;
				}
				&.long {
					height: 214px;
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 200px;
		height: 64px;
		.filter-reveal {
			width: 200px;
			margin-top: 64px;
			.filter-dd-wrapper {
				height: 128px;
				&.three {
					height: 145px;
				}
				&.four {
					height: 180px;
				}
				&.long {
					height: 225px;
				}
				.selected {
					height: 48px;
				}
				.filter-selections {
					padding: 32px;
					padding-right: 48px;
					padding-top: 16px;
					height: 200px;
					.ScrollbarsCustom-Track {
						right: 20px !important;
						top: 0px !important;
					}

					.ScrollbarsCustom-ThumbY {
						width: 10px !important;
					}
					.ScrollbarsCustom-TrackY {
						width: 10px !important;
					}
				}
			}
		}
		.filter-selected {
			height: 64px;

			.filter-title {
				.title {
					margin-bottom: 12px;
					&.active {
						color: ${props => handleColorType(props.module, props.theme)};
					}
				}
				.filter-icon-2 {
					width: 32px;
					margin-bottom: 12px;
				}
			}
		}
		.filter-selected:hover {
			.filter-reveal {
				height: 128px;
				&.three {
					height: 145px;
				}
				&.four {
					height: 180px;
				}
				&.long {
					height: 225px;
				}
			}
		}
	}
`;
function onmouseover() {
	const element = document.getElementById('filter-title');
	const icon = document.getElementById('filter-icon-2');
	icon.classList.add('active');
	element.classList.add('active');
}

function onmouseout() {
	const element = document.getElementById('filter-title');
	const icon = document.getElementById('filter-icon-2');
	icon.classList.remove('active');
	element.classList.remove('active');
}

export const Sort = ({ selected, options, callback, module, filterHeading }) => {
	const { sortData, setSortData } = useContext(SortContext);

	useEffect(() => {
		options.sort((a, b) => (a.value > b.value ? 1 : -1));
		setSortData({ selected, filters: options });
	}, []);
	let filters = sortData?.filters;

	function onClick(selected) {
		options.sort((a, b) => (a.value > b.value ? 1 : -1));
		callback(selected);
		setSortData({ selected, filters: options });
	}

	//remove selected from list displayed.
	if (filters) {
		filters = filters.filter(item => item?.displayValue !== sortData?.selected?.displayValue);
	}
	let dataLength = filters?.length > 4 ? 'long' : 'short';
	if (filters?.length === 3) {
		dataLength = 'three';
	}
	if (filters?.length === 4) {
		dataLength = 'four';
	}

	return (
		<SortStyle id='sort' module={module}>
			<div
				className='filter-selected labels21'
				onMouseOver={filters?.length !== 0 && onmouseover}
				onMouseOut={filters?.length !== 0 && onmouseout}
				data-cy='sort-dropdown'
			>
				<div className='filter-title'>
					{filterHeading && <div className='filter-heading labels21'>{filterHeading}</div>}
					<div className='title nav-menu' id='filter-title'>
						{sortData?.selected?.displayValue}
					</div>
					{filters?.length !== 0 && (
						<div className='filter-icon-2' id='filter-icon-2'>
							<DownArrowSVG />
						</div>
					)}
				</div>
				{filters?.length !== 0 && (
					<div className={`filter-reveal ${dataLength}`}>
						<div className={`filter-dd-wrapper ${dataLength}`}>
							<div className='selected footer15'>{sortData?.selected?.displayValue}</div>
							<div className='filter-selections'>
								<Divider />
								<ScrollView>
									<div className='selectors'>
										{filters &&
											filters.map(filter => (
												<div className='selector footer16' onClick={() => onClick(filter)}>
													{filter.displayValue}
												</div>
											))}
									</div>
								</ScrollView>
							</div>
						</div>
					</div>
				)}
			</div>
		</SortStyle>
	);
};

Sort.propTypes = {
	module: string,
};

Sort.defaultProps = {
	module: 'support',
};
